import { Button } from "flowbite-react";
import OrderItemRow from "./OrderItemRow";
import { useLocation } from "react-router-dom";

export const tableHeaders = [
  { placeholder: "Image", apiName: "Record_Image", onlyInfoKey: "something" },
  {
    placeholder: "Code",
    apiName: "Product_Code",
    onlyInfoKey: "Item_Code",
  },
  {
    placeholder: "Name",
    apiName: "Product_Name",
    onlyInfoKey: "Product_Name",
  },
  { placeholder: "HSN Code", apiName: "HS_Code" },
  { placeholder: "Description", apiName: "Description" },
  { placeholder: "UOM", apiName: "Usage_Unit", onlyInfoKey: "UOM" },
  { placeholder: "Min Order QTY.", apiName: "Minimum_Order_level" },
  {
    placeholder: "Requested Quantity",
    apiName: "Requested_Quantity",
    onlyInfoKey: "Requested_Quantity",
  },
  {
    placeholder: "Actual Quantity",
    apiName: "Quantity",
    onlyInfoKey: "Quantity",
  },
  {
    placeholder: "Remarks",
    apiName: "MOQ_Remarks",
    onlyInfoKey: "MOQ_Remarks",
  },
  {
    placeholder: "List Price ($)",
    apiName: "Unit_Price",
    onlyInfoKey: "List_Price",
  },
  {
    placeholder: "Discounted Price ($)",
    apiName: "Distributors_Discount_Price",
    onlyInfoKey: "Channel_Discounted_Price",
  },
  {
    placeholder: "Total Value ($)",
    apiName: "Total_Value",
    onlyInfoKey: "Total_Value",
    onlyInfo: true,
  },
  { placeholder: "Actions", apiName: "actions", onlyInfo: false },
  {
    placeholder: "In Stock",
    apiName: "Stock_Available",
    onlyInfoKey: "Stock_Availble",
    onlyInfo: true,
  },
];

const OrderItems = ({
  formData,
  handleItemChange,
  removeItem,
  setOpenModal,
  onlyInfo = false,
  isReturn,
}) => {
  const location = useLocation();
  // filter out url where we need to showcase the requested quantity
  const isForDefaultQyuantity = location.pathname.startsWith("/order-history/");
  console.log("Total_Custom_Discount_1", formData.Total_Custom_Discount_1);
  console.log({formData});
  
  return (
    <div>
      <div className="flex gap-x-5 justify-between mb-6 mt-14">
        <h3 className="text-lg font-semibold mb-4">
          {isReturn ? "Return Items" : "Order Items"}
        </h3>
        {!onlyInfo && !isReturn && (
          <Button
            onClick={() => setOpenModal(true)}
            className="bg-blue-500 text-white"
          >
            Add Item
          </Button>
        )}
      </div>

      {formData.Orders_Items.length === 0 ? (
        <p className="text-red-500">
          {isReturn
            ? "In this order not added any items"
            : "Please add items to your cart before creating a purchase order."}
        </p>
      ) : (
        <div className="max-w-full overflow-x-auto rounded-xl relative">
          <table className="min-w-full table-fixed text-sm text-left text-gray-500 dark:text-gray-400">
            {formData.Total_Custom_Discount_1 > 0 &&
            ![
              "Void",
              "Pending For Availability Check",
              "Pending for Approval - CEO",
              "Pending for Approval - Country Manager",
              "Pending for Approval"
            ].includes(formData.Stage) ? (
              <span
                className="absolute left-0 top-0 bg-green-500 text-white p-2"
                style={{
                  transform: "rotate(-45deg)",
                  top: "-5px",
                  left: "-25px",
                  fontSize: "12px",
                  textAlign: "center",
                  width: "77px",
                }}
              >
                {formData.Total_Custom_Discount_1}%
              </span>
            ) : ''}

            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                {tableHeaders.map((header, index) => {
                  if (
                    (header.apiName === "Requested_Quantity" &&
                      !isForDefaultQyuantity) ||
                    (onlyInfo && !header?.onlyInfoKey) ||
                    (header.onlyInfoKey === "Stock_Availble" &&
                      formData?.Stage !== "Confirm" &&
                      onlyInfo)
                  )
                    return null;

                  if (header.apiName === "Quantity" && isForDefaultQyuantity) {
                    return (
                      <th className={`px-6 py-3 text-center`} key={index}>
                        <span>Confirmed Quantity</span>
                      </th>
                    );
                  }

                  if (header.onlyInfo && onlyInfo) {
                    return (
                      <th
                        className={`px-6 py-3 ${
                          ["Description"].includes(header.apiName)
                            ? "min-w-60 text-center"
                            : ""
                        }`}
                        key={index}
                      >
                        <span>{header.placeholder}</span>
                      </th>
                    );
                  } else if (!header.onlyInfo) {
                    return (
                      <th
                        className={`px-6 py-3 w-32 ${
                          ["Description"].includes(header.apiName)
                            ? "min-w-60 text-center"
                            : ""
                        }`}
                        key={index}
                      >
                        {header.placeholder}
                      </th>
                    );
                  }
                  return null;
                })}
              </tr>
            </thead>
            <tbody>
              {formData.Orders_Items.map((item, index) => (
                <OrderItemRow
                  handleItemChange={handleItemChange}
                  index={index}
                  item={item}
                  removeItem={removeItem}
                  key={index}
                  onlyInfo={onlyInfo}
                  stage={formData?.Stage}
                  formData={formData}
                  isReturn={isReturn}
                />
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default OrderItems;
